<template>
  <div class="error-page">
    <div class="error-container">
      <div class="error-image">
        <div class="error-number">404</div>
        <div class="error-illustration">
          <van-icon name="warning-o" size="64" />
        </div>
      </div>
      <h2 class="error-title">页面未找到</h2>
      <p class="error-description">抱歉，您访问的页面不存在或已被移除</p>
      <div class="error-actions">
        <van-button round type="primary" class="action-button" @click="back('back')">
          <van-icon name="arrow-left" />
          <span>返回上一页</span>
        </van-button>
        <van-button round type="info" class="action-button" @click="back('sm')">
          <van-icon name="scan" />
          <span>返回扫码界面</span>
        </van-button>
      </div>
    </div>
  </div>
</template>
<script>

import router from "@/router"

export default {
  name: "errorPage",
  components: {},
  data() {
    return {}
  },
  created() {
    // 隐藏导航栏
    this.hideNavigation();
  },
  beforeDestroy() {
    // 恢复导航栏
    this.restoreNavigation();
  },
  methods: {
    back(tag) {
      if (tag === 'sm') {
        router.push("/qrLogin/")
      } else {
        this.$router.go(-1);
      }
    },
    // 隐藏导航栏
    hideNavigation() {
      // 尝试查找并隐藏导航元素
      const navElements = document.querySelectorAll('nav, .nav, .navigation, .sidebar, aside');
      navElements.forEach(el => {
        if (el && el.style) {
          el._originalDisplay = el.style.display;
          el.style.display = 'none';
        }
      });
      
      // 如果有特定ID或类的导航栏，也可以直接隐藏
      const specificNav = document.getElementById('app-navigation');
      if (specificNav) {
        specificNav._originalDisplay = specificNav.style.display;
        specificNav.style.display = 'none';
      }
    },
    // 恢复导航栏
    restoreNavigation() {
      const navElements = document.querySelectorAll('nav, .nav, .navigation, .sidebar, aside');
      navElements.forEach(el => {
        if (el && el.style && el._originalDisplay !== undefined) {
          el.style.display = el._originalDisplay;
        }
      });
      
      const specificNav = document.getElementById('app-navigation');
      if (specificNav && specificNav._originalDisplay !== undefined) {
        specificNav.style.display = specificNav._originalDisplay;
      }
    }
  }
}
</script>

<style lang="less" scoped>
.error-page {
  min-height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(to bottom, #f7f8fa, #edf2f7);
  padding: 20px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  box-sizing: border-box;
}

.error-container {
  max-width: 500px;
  width: calc(100% - 40px);
  text-align: center;
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  padding: 40px 20px;
  animation: fadeIn 0.8s ease-out, float 3s ease-in-out infinite alternate;
  position: relative;
  margin: 0 auto;
}

.error-image {
  position: relative;
  height: 160px;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.error-number {
  font-size: 120px;
  font-weight: bold;
  color: #f2f3f5;
  position: absolute;
  width: 100%;
  text-align: center;
  z-index: 1;
  letter-spacing: 4px;
}

.error-illustration {
  position: relative;
  z-index: 2;
  color: #1989fa;
  animation: pulse 2s infinite;
}

.error-title {
  font-size: 24px;
  color: #323233;
  margin-bottom: 12px;
  font-weight: 600;
}

.error-description {
  font-size: 16px;
  color: #909399;
  margin-bottom: 30px;
}

.error-actions {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 360px;
  margin: 0 auto;
  width: 100%;
}

.action-button {
  width: 100%;
  min-width: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
  height: 44px;
  
  .van-icon {
    margin-right: 8px;
    font-size: 18px;
  }
  
  span {
    white-space: nowrap;
    font-size: 15px;
  }
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

@keyframes float {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-10px);
  }
}

@media (min-width: 768px) {
  .error-container {
    padding: 50px 30px;
    width: auto;
  }
  
  .error-actions {
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
  }
  
  .action-button {
    width: auto;
    min-width: 180px;
    padding: 0 30px;
    margin: 0 8px;
  }
}

@media (max-width: 767px) {
  .error-container {
    width: calc(100% - 40px);
    padding: 30px 15px;
  }
  
  .error-number {
    font-size: 100px;
  }
}
</style>